const CHUNK_RELOAD_STORAGE_KEY = 'forstok:chunk-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

const CHUNK_LOAD_ERROR_MESSAGES = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'unable to preload css',
  'failed to load module script',
];

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;

  return '';
};

export const isChunkLoadError = (error: unknown): boolean => {
  const message = getErrorMessage(error).toLowerCase();

  return CHUNK_LOAD_ERROR_MESSAGES.some((expectedMessage) => message.includes(expectedMessage));
};

export const reloadAfterChunkLoadError = (): boolean => {
  const now = Date.now();

  try {
    const lastReload = Number(window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY));

    if (Number.isFinite(lastReload) && now - lastReload < CHUNK_RELOAD_COOLDOWN_MS) {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now));
  } catch {
    // Without persistent storage, an automatic reload could create a reload loop.
    return false;
  }

  window.location.reload();
  return true;
};

export const handleVitePreloadError = (event: Event): void => {
  // Vite rethrows the import error unless the event is cancelled.
  event.preventDefault();
  reloadAfterChunkLoadError();
};
